// extracted by mini-css-extract-plugin
module.exports = {"localeSwitcher":"LocaleSwitcher_localeSwitcher__d8_fq","link":"LocaleSwitcher_link__AmrCD","active":"LocaleSwitcher_active__UaDnE"};